import { formatPercent } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class MinstrelsPodiumBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MINSTRELS_PODIUM;

	public get description(): string {
		return super.description.replace(
			"{percent}",
			this.multiplierPercentage,
		);
	}

	public get multiplierPercentage(): string {
		return formatPercent(
			(this.config.production.get(
				ResourceType.PRODUCTION_RESOURCE_MULTIPLIER,
			)! as number) - 1,
		);
	}

	// explicit valentine multi-pack synergy targets (LB popup)
	public get boostedBuildings(): Array<FrameName> {
		// TODO: uz to mame v supplies
		return [FrameName.BANQUET];
	}
}

export default MinstrelsPodiumBuildingTileEntity;
